import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector, getFormValues } from 'redux-form';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from '../../../text/messages';
import { CheckboxField, RadioField } from './../../../components/fields';
import Document from './../../../components/document';
import WizardButtons from '../../../components/wizard/navigator/buttons';
import { getAdmin } from '../../../reducers/onboarding';
import { updateUserDetails, getUserDetails, submitOnboarding } from '../../../reducers/identity';
import { getRequirements } from '../../../reducers/tenants';
import { ConfirmationDialog } from '../../../components/dialogs';
import Box from '../../../components/box';
import { Snackbar } from '../../../components/snackbar';
import { DocumentInfo, PERMISSIONS } from '../../../utilities/documentTypes';
import { anythingChanged } from '../../../utilities/common';

class ProgramPolicies extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: { open: false, values: undefined }
        };

        this.submit = this.submit.bind(this);
        this.getBGCheckOptions = this.getBGCheckOptions.bind(this);

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        let { admin, client, getAdmin } = this.props;
        if (!admin) getAdmin(client.admin_id);
    }

    onOpen(values) {
        this.setState({ modal: { open: true, values } });
    }

    onClose() {
        this.setState({ modal: { open: false, values: undefined } });
    }

    getBGCheckOptions() {
        const { policies } = this.props;
        const { job_policies } = policies;
        const { bg_check_type } = job_policies;

        return [
            {
                value: 'basic',
                label: (
                    <div className="">
                        <i className="material-icons">{bg_check_type === 'basic' ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                        <FormattedMessage {...messages.basic} tagName={'span'} />
                    </div>
                )
            },
            {
                value: 'enhanced',
                label: (
                    <div className="">
                        <i className="material-icons">{bg_check_type === 'enhanced' ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                        <FormattedMessage {...messages.enhanced} tagName={'span'} />
                    </div>
                )
            }
        ];
    }

    submit(values, action) {
        const { role, client, updateUserDetails, getUserDetails, getRequirements, submitOnboarding } = this.props;

        updateUserDetails(role, { ...client, job_policies: values.job_policies }, () => {
            submitOnboarding(client, role, () => {
                getUserDetails(role, () => {
                    getRequirements(role);
                    action();
                });
            });
        });
    }

    renderBGsection() {
        const { client, policies } = this.props;
        const { job_policies } = policies;
        const { bg_check, drug_check } = job_policies;

        return (
            <div>
                <div className="col-xs-12">
                    <FormattedMessage id={'clientOnboarding.backgroundCheck'} defaultMessage={'Background Checks'} tagName={'h5'} />

                    <Field
                        name="job_policies.bg_check"
                        component={CheckboxField}
                        checked={bg_check === true}
                        placeholder={{ ...messages.clientRequiresBackgroundCheck, values: { client: client.name } }}
                        hideErrors
                    />
                </div>
                {bg_check === true && (
                    <div className="col-xs-12 bg-check-type-choice">
                        <Field
                            name="job_policies.bg_check_type"
                            component={RadioField}
                            options={this.getBGCheckOptions()}
                            placeholder={{ ...messages.backgroundCheckType }}
                            hideErrors
                        />
                        <ul>
                            <FormattedHTMLMessage
                                id={'clientOnboarding.companyPolicyDocuments'}
                                defaultMessage={
                                    '<li>National Criminal Search (standard)</li><li>County Criminal Search - last 7 years</li><li>Sex Offender Search</li><li>SSN Trace</li><li>Global Watchlist Search</li>'
                                }
                                tagName={'div'}
                            />
                            {job_policies.bg_check_type === 'enhanced' && (
                                <FormattedHTMLMessage
                                    id={'clientOnboarding.companyPolicyDocuments'}
                                    defaultMessage={'<li>+ Employment Verification (current position)</li><li>+ Education Verification</li>'}
                                    tagName={'div'}
                                />
                            )}
                        </ul>
                    </div>
                )}
                <div className="col-xs-12">
                    <Field
                        name="job_policies.drug_check"
                        component={CheckboxField}
                        checked={drug_check === true}
                        placeholder={{ ...messages.clientRequiresDrugCheck, values: { client: client.name } }}
                        hideErrors
                    />
                </div>
            </div>
        );
    }

    renderPOsection() {
        const { policies } = this.props;
        const { job_policies } = policies;
        const { individual_po } = job_policies;
        return (
            <div className="col-xs-12">
                <FormattedMessage id={'clientOnboarding.purchaseOrders'} defaultMessage={'Purchase Orders'} tagName={'h5'} />

                <Field
                    name="job_policies.individual_po"
                    component={CheckboxField}
                    checked={individual_po === true}
                    placeholder={{ ...messages.clientRequiresIndividualPO }}
                    hideErrors
                />
            </div>
        );
    }

    renderDocsSection() {
        const { admin, client } = this.props;
        const { CLIENT_NDA, CLIENT_PIIA, CLIENT_TRAINING, OTHER } = DocumentInfo.types;
        return (
            <div className="col-xs-12">
                <FormattedMessage id={'clientOnboarding.companyPolicyDocuments'} defaultMessage={'Company Policy Documents'} tagName={'h5'} />
                <FormattedHTMLMessage {...messages.companyPolicyDocumentsExplanation} values={{ admin: admin.name, client: client.name }} tagName={'p'} />

                <Document
                    id={'clientOnboardingNDA'}
                    {...CLIENT_NDA}
                    upload={{ limit: 1, permissions: PERMISSIONS.CLIENT_UPLOAD }}
                    view={{ showHeader: false }}
                />
                <Document id={'clientPIIA'} {...CLIENT_PIIA} upload={{ limit: 1, permissions: PERMISSIONS.CLIENT_UPLOAD }} view={{ showHeader: false }} />
                <Document
                    id={'clientOnboardingTraining'}
                    {...CLIENT_TRAINING}
                    upload={{ limit: 1, permissions: PERMISSIONS.CLIENT_UPLOAD }}
                    view={{ showHeader: false }}
                />
                <Document
                    id={'clientExtraDoc1'}
                    {...OTHER}
                    upload={{ limit: OTHER.limit, permissions: PERMISSIONS.CLIENT_UPLOAD }}
                    view={{ showHeader: false }}
                />
            </div>
        );
    }

    renderClassificationSection() {
        const { client, policies } = this.props;
        const { job_policies } = policies;
        const { w2_only, ic_only } = job_policies;
        return (
            <div className="col-xs-12">
                <FormattedMessage {...messages.workerClassification} tagName={'h5'} />
                <FormattedHTMLMessage {...messages.clientW2ICexplanation} tagName={'p'} />
                <Field
                    name="job_policies.w2_only"
                    component={CheckboxField}
                    checked={w2_only === true}
                    placeholder={{ ...messages.clientW2Only, values: { client: client.name } }}
                    hideErrors
                    onChange={(_, newValue) => {
                        if (newValue) {
                            job_policies.ic_only = false;
                        }
                    }}
                />
                <Field
                    name="job_policies.ic_only"
                    component={CheckboxField}
                    checked={ic_only === true}
                    placeholder={{ ...messages.clientICOnly, values: { client: client.name } }}
                    hideErrors
                    onChange={(_, newValue) => {
                        if (newValue) {
                            job_policies.w2_only = false;
                        }
                    }}
                />
            </div>
        );
    }

    renderInsuranceSection() {
        const { admin, client, policies } = this.props;
        const { job_policies } = policies;
        const { ic_waive_insurance } = job_policies;
        return (
            <div>
                <div className="col-xs-12">
                    <FormattedMessage id={'clientOnboarding.ICInsurance'} defaultMessage={'Independent Contractor Insurance'} tagName={'h5'} />
                    <FormattedHTMLMessage {...messages.clientAllowsICExplanation} values={{ admin: admin.name, client: client.name }} tagName={'div'} />
                </div>
                <div className="col-xs-12">
                    <Field
                        name="job_policies.ic_waive_insurance"
                        component={CheckboxField}
                        checked={ic_waive_insurance === true}
                        placeholder={{ ...messages.icWaiveInsurance }}
                        hideErrors
                    />
                </div>
            </div>
        );
    }

    render() {
        const { modal } = this.state;
        const { handleSubmit, submitting, admin, isPristine } = this.props;

        if (!admin) {
            return null;
        }

        return (
            <div>
                <form onSubmit={handleSubmit(values => this.onOpen(values))}>
                    <Box content={this.renderBGsection()} />
                    <Box content={this.renderPOsection()} />
                    <Box content={this.renderDocsSection()} />
                    <Box content={this.renderClassificationSection()} />
                    <Box content={this.renderInsuranceSection()} />

                    <WizardButtons disabled={submitting || isPristine} submit={{ message: <FormattedMessage {...messages.update} /> }} />
                </form>
                <ConfirmationDialog
                    modal={modal}
                    message={<FormattedMessage {...messages.updatingConfirmation} values={{ entity: 'program policies' }} />}
                    onClose={this.onClose}
                    onSubmit={() => {
                        this.submit(modal.values, () => {
                            this.onClose();
                            Snackbar.success(<FormattedMessage {...messages.companyInfoUpdated} />);
                        });
                    }}
                />
            </div>
        );
    }
}

ProgramPolicies = reduxForm({
    form: 'client-company-policies',
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: false
})(ProgramPolicies);

const selector = formValueSelector('client-company-policies');

const mapStateToProps = state => {
    let defaultValue = {
        job_policies: {
            bg_check: false,
            bg_check_type: undefined,
            drug_check: false,
            individual_po: false,
            w2_only: false,
            ic_only: false,
            ic_waive_insurance: false
        }
    };
    let client = state.identity.details;
    const initialValues = client.job_policies ? { job_policies: client.job_policies } : defaultValue;
    const formValues = getFormValues('client-company-policies')(state);
    const isPristine = anythingChanged({ initialValues, values: formValues });

    return {
        role: state.identity.role,
        client,
        admin: state.onboarding.admin,
        policies: selector(state, 'job_policies') ? { job_policies: selector(state, 'job_policies') } : defaultValue,
        initialValues,
        isPristine
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            updateUserDetails: updateUserDetails,
            submitOnboarding: submitOnboarding,
            getUserDetails: getUserDetails,
            getRequirements: getRequirements
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ProgramPolicies);



// WEBPACK FOOTER //
// ./src/pages/company/forms/programPolicies.jsx